import { EditionType } from '@graphics/gfx-common/dist/constants'
import { safePost } from './http'
import { editionsUrl } from './pack'

export const createEditionFromDataChart = (
  packId: string,
  title: string,
  dataStreamURI: string
) =>
  safePost(editionsUrl(packId), {
    editionType: EditionType.DataStreamGraphic,
    title: '',
    dataStreamGraphic: {
      dataStreamURI,
    },
  })
